<template>
  <div v-if="popupActive" class="create-task-popup">
    <PopUp
      bottom
      :title="$t('建立任務')"
      :clickOutsideClose="false"
      :pop-up-active="popupActive"
      :isLoading="isLoading"
      @click="$_popupClose()"
    >
      <ListCard
        v-if="systemSubclasses.length > 0"
        is-table
        white
        no-padding
      >
        <ListCardItem
          v-if="systemSubclasses.length > 0"
          is-table
          row
          type="chip-list"
          :title="$t('領域')"
          :chip-list="systemSubclasses"
        />
      </ListCard>
      <ValidationObserver ref="formObserver">
        <InputListCard>
          <div class="input-item">
            <StateInputButton
              v-model="taskData.taskName"
              :placeholder="$t('輸入')"
              text-length="3000"
              :text-number="_titleLength"
              :title="$t('主旨')"
              required
              rules="required"
            />
          </div>
          <div class="input-item">
            <InputTextareaButton
              v-model="taskData.taskContent"
              :min-height="134"
              :title="$t('說明')"
              :placeholder="$t('輸入')"
              required
              rules="required"
            />
          </div>
          <div class="multiple-input-item">
            <div class="input-item">
              <StateDatePickerInput
                v-model="taskData.endDate"
                :disabled-date="$moment().toDate()"
                not-before-disabled-date
                :title="$t('期限')"
                leading-icon="icon-datestart"
                required
                rules="required"
              />
            </div>
            <div class="input-item">
              <DropdownSelectMenuButton
                v-model="taskData.taker"
                :select-value="taskData.takerValue"
                :placeholder="$t('選擇')"
                :title="$t('負責人')"
                leading-icon="icon-outline-perm-identity"
                outline
                avatar-select
                required
                rules="required"
              />
            </div>
          </div>
          <div class="input-item">
            <LvStateFactoryTag
              v-model="taskData.factoryTags"
            />
          </div>
        </InputListCard>
        <ToDoCardList
          :error="subTaskError"
          :title="$t('待辦事項')"
          button
          sort-edit
          :list="taskData.subTasks"
          :propsMenuItems="multipleSystemClassMenu"
          @sorting-complete="$_sortingComplete($event)"
          @sorting-active="$_sortingActive($event)"
          @add-sub-task-from-task="$_onAddSubTaskFromTask"
        >
          <ToDoCardEdit
            v-for="(subTask,subTaskIndex) in taskData.subTasks"
            :key="subTaskIndex"
            v-model="taskData.subTasks[subTaskIndex]"
            :uploadModule="uploadModule"
            :propsMenuItems="multipleSystemClassMenu"
            @go-to="$_onGoToFile($event)"
            @delete="$_deleteSubTask(subTaskIndex)"
          />
          <template v-slot:buttons>
            <WsTextButton001
              leading-icon="icon-add"
              @click=" $_createSubTask()"
            >
              {{ $t('新增') }}
            </WsTextButton001>
          </template>
        </ToDoCardList>
      </ValidationObserver>
      <EventCardList
        v-if="_eventCardList.length > 0"
        row
        :event-list="_eventCardList"
      />
      <template slot="bottomBtn">
        <WsButton001
          out-line
          width200
          @click="$_popupClose()"
        >
          {{ $t('取消') }}
        </WsButton001>
        <WsButton001
          width200
          :disable="taskData.subTasks.length>0&&isSorting"
          :isloading="submitLoading"
          @click="$_btnSubmitClick()"
        >
          {{ $t('建立') }}
        </WsButton001>
      </template>
    </PopUp>
  </div>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import taskService from "@/service/api/v1/task";
import systemClass from "@/service/api/v1/system_class";
import H_file from '@/helpers/file';
import H_systemClassMenu from '@/helpers/systemClassMenu';
import Spare_file from '@/spare/file';

export default {
  name: "CreateTaskPopup",
  components: {
    ValidationObserver,
  },
  props: {
    defaultTaskName: {
      type: String,
      default() {
        return this.$t("相關任務");
      },
    },
    popupActive: {
      type: Boolean,
      default: false,
    },
    systemSubclasses: {
      type: Array,
      default() {
        return [];
      },
    },
    changeId: {
      type: String,
    },
    changeVerison: {
      type: [Number, String],
      default: 0,
    },
    defaultTaskTaker: {
      type: Object,
      default() {
        return {};
      },
    },
    defaultSubtasks: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data: () => ({
    submitLoading: false,
    subTaskError: false,
    isSorting: false,
    isLoading: true,
    multipleSystemClassMenu: [],

    taskData: {
      taskName: "",
      taskContent: "",
      taker: null,
      takerValue: null,
      endDate: "",
      subTasks: [],
      factoryTags: [],
    },
    uploadModule: Spare_file.uploadModule.task,
  }),
  computed: {
    _defaultTaskName() {
      return this.defaultTaskName;
    },
    _eventCardList() {
      let eventCardList = [];
      if (this.changeId) {
        eventCardList.push({
          id: this.changeId,
          type: "change",
        });
      }
      return eventCardList;
    },
    _titleLength() {
      return this.taskData.taskName.length;
    },
    _currentFactoryId() {
      return this.$store.state.app.factoryId;
    },
    _currentFactory() {
      return this.$store.state.app.factory;
    },
    _currentUser() {
      return this.$store.state.stone_auth.currentUser;
    },
    _allSystemClass() {
      if (!this.$store.state.model.systemClasses) {
        return [];
      } else {
        return this.$store.state.model.systemClasses;
      }
    },
    _systemSubclassesItems() {
      return systemClass.setSystemClassesItems(this._allSystemClass);
    },
  },
  watch: {
    _defaultTaskName: {
      deep: true,
      handler() {
        if (this.defaultTaskName) {
          this.taskData.taskName = this.defaultTaskName;
        }
      },
    },
    defaultSubtasks: {
      deep: true,
      immediate: true,
      handler() {
        if (this.defaultSubtasks && this.defaultSubtasks.length > 0) {
          this.taskData.subTasks = this.defaultSubtasks;
        } else if (!this.taskData.subTasks.length) {
          this.$_createSubTask();
        }
      },
    },
    popupActive() {
      this.$_setDefaultData();
    }
  },
  async mounted() {
    try {
      this.isLoading = true;
      this.multipleSystemClassMenu = await H_systemClassMenu.fetchMultiSystemClassMenu({
        systemClasses: this.$store.state.model.systemClasses,
      });
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    $_setDefaultData() {
      if (this.defaultTaskTaker) {
        this.taskData.taker = this.defaultTaskTaker.id;
        this.taskData.takerValue = this.defaultTaskTaker;
      }
      if (this.defaultTaskName) {
        this.taskData.taskName = this.defaultTaskName;
      }
      if (this.defaultSubtasks && this.defaultSubtasks.length > 0) {
        this.taskData.subTasks = this.defaultSubtasks;
      }
    },
    $_createSubTask() {
      this.taskData.subTasks.push({
        done_at: null,
        start_at: "",
        expired_at: "",
        name: "",
        remark: "",
        taker: null,
        attaches: [],
      });
    },
    $_deleteSubTask(index) {
      if (this.taskData.subTasks.length === 1) {
        this.subTaskError = true;
        return;
      }
      this.taskData.subTasks.splice(index, 1);
    },
    $_popupClose() {
      this.$emit("btn-close");
    },
    async $_btnSubmitClick() {
      if (!this.taskData.subTasks.length) return;
      const isValidate = await this.$refs.formObserver.validate();
      if (!isValidate || this.submitLoading === true) {
        return;
      }
      const res = await this.$_createTask();
      this.$emit("submit", res);
      this.$_popupClose();
    },
    async $_createTask() {
      this.submitLoading = true;
      const _subClasses = this.systemSubclasses.map((item) => item.id);
      const data = {
        change_version: this.changeVerison,
        done_at: null,
        checked_at: null,
        expired_at: this.taskData.endDate,
        name: this.taskData.taskName,
        remark: this.taskData.taskContent,
        taker: this.taskData.taker,
        creator: this._currentUser.id,
        system_classes: systemClass.getSelectedSystemClasses(
          _subClasses,
          this._systemSubclassesItems
        ),
        system_subclasses: _subClasses,
        sub_tasks: this.$_getSubtaskAttaches(this.taskData.subTasks),
        factory_tags: this.taskData.factoryTags[0],
      };
      const res = await taskService.createTask(this._currentFactoryId, data);
      this.submitLoading = false;
      if (res) return res;
    },
    $_getSubtaskAttaches(subTasks) {
      let originalSubtasks = JSON.parse(JSON.stringify(subTasks));
      originalSubtasks.forEach((subTask) => {
        subTask.attaches = H_file.setSubmitInModule(subTask.attaches);
        subTask.factory = this._currentFactoryId;
      });
      return originalSubtasks;
    },
    $_sortingComplete($event) {
      this.taskData.subTasks = $event;
    },
    $_sortingActive($event) {
      this.isSorting = $event;
    },
    $_onGoToFile($event) {
      H_file.goToFile($event);
    },
    $_onAddSubTaskFromTask() {
      const isFirstSubTaskHasValue = this.taskData.subTasks[0].name !== '' || this.taskData.subTasks[0].remark !== '';
      if (isFirstSubTaskHasValue) {
        this.taskData.subTasks.push({
          done_at: null,
          start_at: "",
          expired_at: "",
          name: this.taskData.taskName,
          remark: this.taskData.taskContent,
          taker: null,
          takerValue: {},
          attaches: [],
          images: [],
          errors: [],
        });
      } else {
        this.taskData.subTasks[0].name = this.taskData.taskName;
        this.taskData.subTasks[0].remark = this.taskData.taskContent;
      }
    }
  },
};
</script>
<style lang="scss" >
@import "@/assets/scss/component/create-task-popup";
</style>